export const PORTFOLIO_TABLE_CONFIG = {
    name            : 'Task table',
    menuName        : 'Table',
    icon            : 'i5-table',
    // iconLight       : 'i5-table-light',
    image           : 'table',
    iconSvg         : 'isvg-view-table',
    url             : 'table',
    stringId        : 'tasks_table',
    description     : 'Advanced spreadsheet-like tasks view with project hierarchy support.'
}
